<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="alert alert-primary" role="alert">
                <div class="d-flex justify-content-between">
                    <div class="d-flex">
                        <i class="fas fa-info-circle fa-lg mt-1"></i>
                        <div class="info-text ml-2">
                            <div><span class="font-weight-bold">INFORMATION:</span> A payer contract is associated with this health insurance claim. The estimated reimbursement does not reflect the terms of the contract.</div>
                            <div><span class="font-weight-bold">Description:</span> {{ contract.description}}</div>
                            <div class="d-flex">
                                <div v-if="contract.activated_at"><span class="font-weight-bold">Activated:</span> {{ contract.activated_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</div>
                                <div v-if="contract.terminated_at" class="ml-3"><span class="font-weight-bold">Terminated:</span> {{ contract.terminated_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <a :href="`/clients/${contract.client_id}/payercontracts/${contract.id}`" class="btn btn-sm btn-primary" target="_blank" title="View Contract">View</a>
                        <button class="btn btn-sm btn-danger" title="Remove Contract" @click="confirm()">Remove</button>
                    </div>
                </div>
            </div>                                            
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        clientId: Number,
        claimId: Number,
        serviceFormId: Number,
        historical: Boolean,        
        contract: Object
    },
    methods: {
        confirm: function () {
            const title = "Remove Contract";
            const message = '<span class="font-weight-bold mt-2">Are you sure you want to remove the contract from this claim?</span>';
            eventHub.$emit('show-confirmation', title, message, this.remove); 
        },
        remove: function (confirmed) {

            if (confirmed) {

                let url = this.historical ?
                    `/ajax/clients/${this.clientId}/claims/${this.claimId}/historical/services/${this.serviceFormId}/contract` :
                    `/ajax/clients/${this.clientId}/claims/${this.claimId}/services/${this.serviceFormId}/contract`;

                axios.patch(url)
                .then(repsonse => {})
                .catch(error => {});                
            }
        }
    }
}
</script>

<style scoped>
    .info-text {
        line-height: 1.25;
    }
</style>